import $ from 'jquery';
import Vue from '../vueCommon';

export const VueDropdownComponent = Vue.component('dropdown', {
    props: {
        id: String,
        inline: {
            type: Boolean,
            default: false
        },
        defaultText: String,
        noResultsMessage: String,
        listItemTitle: String,
        searchItemTitle: String,
        text: String,
        placeholder: {
            type: String,
            default: ''
        },
        formatText: {
            type: Boolean,
            default: false
        },
        orientation: {
            type: String,
            default: 'bottom'
        },
        listItems: {
            type: Array,
            default: () => []
        },
        searchItems: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            isExpanded: false,
            hasInput: false,
            isUserScrolling: false
        };
    },
    computed: {
        hasValue() {
            return !!this.text;
        },
        showListItems() {
            return this.listItems.length && !this.hasInput;
        },
        showSearchItems() {
            return !!this.searchItems.length;
        }
    },
    mounted() {
        $('body').on('keypress', event => {
            if (event.key === 'Escape') {
                this.handleBlur();
            }
        });
    },
    methods: {
        getText() {
            if (this.isExpanded) {
                return '';
            }

            let text = this.text || this.defaultText;

            if (this.formatText) {
                text = text.charAt(0).toLowerCase() + text.slice(1);
            }

            return text;
        },

        collapse(withDelay = false) {
            const _collapse = () => {
                this.isExpanded = false;
                this.hasInput = false;

                $(this.$el).find(':focus').blur();
            };

            if (withDelay) {
                setTimeout(_collapse, 100);
            } else {
                _collapse();
            }
        },

        handleFocus(event) {
            this.isExpanded = true;
            $(this.$refs.input).focus();
        },

        handleBlur() {
            setTimeout(() => {
                const hasFocus = !!$(this.$el).find(':focus').length;

                if (!hasFocus) {
                    this.collapse();
                    this.$emit('change-input', null);
                }
            }, 100);
        },

        changeListItem(listItem) {
            if (this.isUserScrolling) {
                return;
            }

            this.collapse(true);
            this.$emit('change-list-item', listItem);
        },

        changeSearchItem(searchItem) {
            if (this.isUserScrolling) {
                return;
            }

            this.collapse(true);
            this.$emit('change-search-item', searchItem);
        },

        changeInput(event) {
            const innerText = event.target.innerText;

            this.hasInput = !!innerText.length;

            if (event.key === 'Enter') {         //  When hitting the enter key
                event.preventDefault();

                if (this.hasInput) {
                    if (this.searchItems.length) {
                        this.changeSearchItem(this.searchItems[0]);      //  Select first search item
                    } else {
                        this.$emit('no-results', innerText);
                        this.collapse();
                    }
                }

                return false;
            }

            this.$emit('change-input', innerText);
        },

        handleButtonClick(event) {
            if (this.hasValue) {
                this.handleReset(event);
            } else if (!this.isExpanded) {
                this.handleFocus(event);
            } else {
                event.preventDefault();
            }
        },

        handleReset() {
            if (this.isUserScrolling) {
                return;
            }

            this.collapse(true);

            this.$emit('reset');
        },

        handleTouchStart() {
            this.isUserScrolling = false;
        },

        handleTouchMove() {
            this.isUserScrolling = true;
        }
    },
    template: `
        <div class="dropdown" :class="{ 'dropdown--inline': inline, 'is-expanded': isExpanded, 'has-input': hasInput, 'has-value': hasValue }" :data-orientation="orientation">
            <div class="dropdown__header">
                <span :id="'input-' + id" class="dropdown__input" contenteditable="true" @focus="handleFocus" @touchend="handleFocus" @blur="handleBlur" @keyup="changeInput" v-html="getText()" ref="input" tabindex="0"></span>
                <div class="dropdown__placeholder" v-html="placeholder" v-if="placeholder"></div>
                <button :id="'button-' + id" class="dropdown__button" @mouseup="handleButtonClick" @touchend="handleButtonClick">
                    <span class="dropdown__icon">
                        <span class="icon" aria-hidden="true"></span>
                    </span>
                </button>
            </div>
            <div class="dropdown__list" v-show="isExpanded && (hasValue && !hasInput || showListItems || showSearchItems || noResultsMessage)" tabindex="-1">
                <button :id="'reset-' + id" type="button" class="dropdown__item dropdown__reset" v-if="hasValue && !hasInput" @mousedown.stop.prevent="handleReset" @touchstart="handleTouchStart" @touchmove="handleTouchMove" @touchend.stop.prevent="handleReset">
                    <span class="icon icon--undo" aria-hidden="true"></span>
                    <span v-html="defaultText"></span>
                </button>
                <slot :collapse="collapse" :is-user-scrolling="isUserScrolling" :handle-touch-start="handleTouchStart" :handle-touch-move="handleTouchMove" :handle-blur="handleBlur"/>
                <div class="dropdown__list-group" v-show="showListItems">
                    <div class="dropdown__list-group-title" v-if="listItemTitle">{% listItemTitle %}</div>
                    <button :id="'list-item-' + id + '-' + index" type="button" class="dropdown__item" v-for="(listItem, index) in listItems" @mousedown.prevent.stop="changeListItem(listItem, $event)" @touchstart="handleTouchStart" @touchmove="handleTouchMove" @touchend.prevent.stop="changeListItem(listItem, $event)" @blur="handleBlur" tabindex="0" v-html="listItem.name"></button>
                </div>
                <div class="dropdown__list-group" v-show="showSearchItems">
                    <div class="dropdown__list-group-title" v-if="searchItemTitle">{% searchItemTitle %}</div>
                    <button :id="'search-item-' + id + '-' + index" type="button" class="dropdown__item" v-for="(searchItem, index) in searchItems" @mousedown.stop.prevent.stop.prevent="changeSearchItem(searchItem, $event)" @touchstart="handleTouchStart" @touchmove="handleTouchMove" @touchend.stop.prevent="changeSearchItem(searchItem, $event)" @blur="handleBlur" tabindex="0" v-html="searchItem.name"></button>
                </div>
                <div class="dropdown__no-results" v-show="!(showListItems || showSearchItems)" v-html="noResultsMessage" v-if="noResultsMessage"></div>
            </div>
        </div>`
});
